import React from 'react';
import { Button } from '@mui/material';
import { useMigrationContext } from './context/Migration_context';

export const MigrationBtn = () => {
    const { setOpenModal } = useMigrationContext();

    return (
        <div style={{ display: 'flex', margin: '0 30px 0 10px' }}>
            <Button variant="contained" color="primary" onClick={() => setOpenModal(true)}>
                Миграция на новую версию
            </Button>
        </div>
    );
};
